import { useState, useEffect } from "react"
import HttpManager from "../../utils/HttpManager";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function CreateAlertModal({ setShowModal }) {

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [contact, setContact] = useState('');

    const [error, setError] = useState({});


    const [loading, setLoading] = useState(false);

    const [submitted, setSubmitted] = useState(false);
    const [userSubscriptions, setUseSubscriptions] = useState([]);
    const [alertType, setAlertType] = useState("");

    useEffect(() => {
        setUseSubscriptions(JSON.parse(localStorage.getItem("UserSubscriptions")));
    }, [])


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);


            const subscriptionAlert = {
                UserSubscriptionID: parseInt(document.getElementById("drpSubscriptions").value),
                AlertType: document.getElementById("drpAlertType") ? document.getElementById("drpAlertType").value : null,
                AlertFrequency: document.getElementById("drpAlertFrequency") ? document.getElementById("drpAlertFrequency").value : null,
                SurgeRatio: document.getElementById("floatingInputSurgeRatio") ? document.getElementById("floatingInputSurgeRatio").value : null
            }

            const response = await new HttpManager(navigate).post("/Alerts/CreateAlert", subscriptionAlert);
            setSubmitted(true);

        } catch (error) {
            console.error("Error while creating alert:", error);
            Swal.fire({
                title: "Error",
                text: "Error occurred while creating subscription alert, Please try again.",
                icon: "error"
            });
        } finally {
            setTimeout(() => setLoading(false) // Mark loading complete
                , 2000);
        }

    };

    return (
        <div className="modal d-block fade show bg-body-secondary p-4 py-md-5 custom-modal-backdrop" tabIndex="-1" role="dialog" id="demoModal" data-bs-backdrop="static" data-bs-keyboard="false" data-bs-focus="false" aria-labelledby="demoModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content rounded-4 shadow">
                    <div className="modal-header p-5 pb-4 border-bottom-0">
                        <h1 className="fw-bold mb-0 fs-2" id="demoModalLable">Create Alert</h1>
                        <button type="button" className="btn-close" onClick={() => setShowModal(false)} aria-label="Close"></button>
                    </div>

                    <div className="modal-body p-5 pt-0">
                        {submitted ? (
                            <div className="text-center">
                                <h4 className="text-success mb-3">Subscription Alert Successfully Created!</h4>
                                <p>You will receive email alerts based on the configuration set in alert.</p>
                                <button className="btn btn-outline-secondary mt-3" onClick={() => setShowModal(false)}>Close</button>
                            </div>
                        ) : (

                            <form onSubmit={handleSubmit}>
                                <div className="form-floating mb-3">
                                    <GetSubscriptionDropdown UserSubscriptions={userSubscriptions} />
                                </div>

                                <div className="form-floating mb-3">
                                    <AlertTypeDropdown setAlertType={setAlertType} />
                                </div>

                                {
                                    alertType !== "Maintenance" && alertType !== "Expiry" &&

                                    <div className="form-floating mb-3">
                                        <AlertFrequencyDropdown />
                                    </div>
                                }

                                {
                                    alertType == "Surge" &&

                                    <div className="form-floating mb-3">
                                        <input type="number" className="form-control rounded-3" id="floatingInputSurgeRatio" placeholder="25%" />
                                        <label htmlFor="floatingInputEmail">Surge Ratio (%)</label>
                                        {/* {error.email && <div className="text-danger mt-2">{error.email}</div>} */}
                                    </div>
                                }

                                {/* <div className="mb-3">
                                    <label htmlFor="formFile" className="form-label"></label>
                                    <input className="form-control" type="file" id="formFile" accept=".wav,audio/wav" onChange={handleFileChange} />
                                    {fileError && <div className="text-danger mt-2">{fileError}</div>}
                                </div> */}

                                <button className="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit" disabled={loading}>

                                    {!loading ? "Create Alert" : (
                                        <>
                                            <span className="dot dot1 mx-2 text-center"></span>
                                            <span className="dot dot2 mx-2"></span>
                                            <span className="dot dot3 mx-2"></span>
                                        </>
                                    )}
                                </button>
                                <hr className="my-4" />
                                <small className="text-body-secondary">Subscription Alerts will be sent to you on the registered email.</small>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

function GetSubscriptionDropdown(props) {


    return (
        <>
            <select id="drpSubscriptions" className="form-select" aria-label="Floating label select example">
                {
                    props.UserSubscriptions.map((subcription) => (
                        <option value={subcription.UserSubscriptionID}>{subcription.SubscriptionName}</option>
                    ))
                }
            </select>
            <label for="floatingSelect">Choose Subscription</label>
        </>
    )
}

function AlertTypeDropdown({ setAlertType }) {
    return (
        <>
            <select id="drpAlertType" className="form-select" aria-label="Floating label select example" onChange={(e) => { setAlertType(e.target.value) }}>
                <option value="Avg Consumption">Avg Consumption</option>
                <option value="Surge">Surge In Consumption</option>
                <option value="Maintenance">Maintenance</option>
                <option value="Expiry">Expiration</option>
            </select>
            <label for="floatingSelect">Choose Alert Type</label>
        </>
    )
}

function AlertFrequencyDropdown(props) {
    return (
        <>
            <select id="drpAlertFrequency" className="form-select" aria-label="Floating label select example">
                <option value="daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Weekly</option>
            </select>
            <label for="floatingSelect">Choose Alert Frequency</label>
        </>
    )
}

export default CreateAlertModal;